import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, IconButton, Chip, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CATEGORY_COLORS = { General: '#94A3B8', Incentive: '#F59E0B', News: '#1A8CFF', Update: '#10B981' };
const API_BASE = process.env.REACT_APP_API_BASE_URL?.replace(/\/api$/, '') || '';

const linkifyText = (text) => {
    if (!text) return text;
    const urlRegex = /(https?:\/\/[^\s<]+)/g;
    const parts = text.split(urlRegex);
    return parts.map((part, i) =>
        urlRegex.test(part)
            ? <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={{ color: '#1A8CFF', wordBreak: 'break-all' }}>{part}</a>
            : part
    );
};

const NoticeDetailModal = ({ notice, open, onClose }) => {
    const navigate = useNavigate();
    if (!notice) return null;

    const getYouTubeEmbedUrl = (url) => {
        if (!url) return null;
        const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/);
        return match ? `https://www.youtube.com/embed/${match[1]}` : null;
    };

    const embedUrl = getYouTubeEmbedUrl(notice.youTubeUrl);

    // The uploaded photo is saved to slideshowImageUrl (absolute URL); older notices
    // may use attachmentUrl (relative). Resolve either, without double-prefixing.
    const rawImg = notice.slideshowImageUrl || notice.attachmentUrl || '';
    const imgUrl = rawImg ? (/^https?:\/\//i.test(rawImg) ? rawImg : `${API_BASE}${rawImg}`) : null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    {notice.title}
                    <Chip label={notice.category} size="small" sx={{ ml: 1, bgcolor: CATEGORY_COLORS[notice.category] || '#94A3B8', color: 'white', fontSize: 10 }} />
                </div>
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent>
                <p style={{ color: '#64748B', fontSize: 12, marginBottom: 12 }}>
                    {new Date(notice.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                    {notice.createdByName && ` · ${notice.createdByName}`}
                </p>
                <p style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{linkifyText(notice.content)}</p>
                {imgUrl && (
                    <img src={imgUrl} alt="attachment" style={{ maxWidth: '100%', borderRadius: 8, marginTop: 12 }} />
                )}
                {embedUrl && (
                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, marginTop: 12 }}>
                        <iframe src={embedUrl} title="YouTube" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0, borderRadius: 8 }} allowFullScreen />
                    </div>
                )}
                {notice.campaignId && (
                    <Button variant="contained" fullWidth onClick={() => { onClose(); navigate(`/incentives/${notice.campaignId}/detail`); }}
                        sx={{ mt: 2, background: 'linear-gradient(135deg, #F59E0B, #D97706)', fontFamily: "'Poppins', sans-serif", fontWeight: 600, textTransform: 'none', borderRadius: '8px', boxShadow: 'none', '&:hover': { background: 'linear-gradient(135deg, #D97706, #B45309)', boxShadow: 'none' } }}>
                        View Campaign Details
                    </Button>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default NoticeDetailModal;
